import { useState } from "react";
import { navLinks } from "@/mocks/home";

export default function TopBar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex cursor-pointer items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
            91
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              91下载
            </span>
            <span className="mt-0.5 text-[11px] tracking-[0.22em] text-foreground-500">
              DOWNLOAD HUB
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="cursor-pointer whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#entry"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-links-line text-base" />
            获取最新入口
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-800 md:hidden"
          >
            <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="cursor-pointer border-b border-background-100 py-3 text-sm text-foreground-700 last:border-0"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#entry"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50"
            >
              <i className="ri-links-line" />
              获取最新入口
            </a>
          </div>
        </div>
      )}
    </header>
  );
}